import styled from 'styled-components'

export const StyledAlertLink = styled.b(({ theme }) => theme.variants.body2.medium, {
  cursor: 'pointer',
  textDecoration: 'underline',
})
